// export const updateValue = (state, payload) => {
//     state.value = payload
//   }

let mutations = {};

mutations.fn_countPhanHoi = (state) => {
    state.phanHoi.refreshFnCountNew++;
};

mutations.fn_initMap = (state) => {
    state.mapBox.refreshMapBox++;
};

export default mutations;

